import { FunctionComponent } from 'react';
import { Typography, Card, CardContent } from '../../tailwindcomponents';
import { BayTailInfo } from '../../types/staffManagement';
import { palette } from '../../theme/palette';

type BayProps = {
    banner_color: string,
    bay: string,
    children?: React.ReactNode;
    bayTailInfo?: BayTailInfo;
    isbay?: boolean;
}

const CardComponent: FunctionComponent<BayProps> = ({ bay, children, banner_color, isbay, bayTailInfo }) => {

    const getWorkPackagesString = (workPackages: { wo_name: string }[]): string => {
        return bayTailInfo?.tailNumber
        ? bayTailInfo.tailNumber + (workPackages?.length ? " | " + workPackages.map(row => row.wo_name).join(' | ') : "")
        : "";
    };

    // Elevation scale for the 4-level nesting (page > bay > group > employee).
    // Bay and group were BOTH palette.backgroundPaper, so four levels read as
    // two. They now alternate raised/recessed, which gives legible depth without
    // piling on shadows; `isbay` is what distinguishes the two.
    return (
        <Card
            style={{
                backgroundColor: isbay ? 'var(--ds-surface)' : 'var(--ds-surface-sunken)',
                border: '1px solid var(--ds-border)',
                boxShadow: isbay ? 'var(--ds-shadow-1)' : 'none',
                borderRadius: 'var(--ds-r-md)',
            }}
        >
        <div
            style={{backgroundColor: banner_color}}
            className="p-[0.2rem] flex items-center justify-center min-h-[1.75rem]"
        >
            <Typography
                textColor={'white'}
                text={`${bay} ${(bayTailInfo !== undefined && isbay) ? ( "    " + getWorkPackagesString(bayTailInfo.workPackages)) : ""}`}
                align='center'
                variant='h4'
            />
        </div>
        <CardContent>
            <div>{children}</div>
        </CardContent>
    </Card>
    
    )
}
export default CardComponent;